
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as lpPeULCK6pVF42z_K_9faFgxzJnN89AqHu63FWtW_45AkhsMeta } from "/app/pages/lp.vue?macro=true";
import { default as txsIe5yRWndhQtEJEURUmRYJeNJ6j3130CIy9Q9aBsJsK0Meta } from "/app/pages/txs.vue?macro=true";
import { default as cardsqx1jMch_45ABk8CQEBHkeTls2ZbGBKMsDjo_XTYXnpx88Meta } from "/app/pages/cards.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta } from "/app/pages/users.vue?macro=true";
import { default as profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta } from "/app/pages/profile.vue?macro=true";
import { default as stakingHaehk2m7OkinPah846w3eiXmTAoM90B68Xme5hYcdEYMeta } from "/app/pages/staking.vue?macro=true";
import { default as indexVbTqsRZ8ivU0twVLNNQVr2sJSPa1OLi2oeqFWQlQ3hQMeta } from "/app/pages/cc/index.vue?macro=true";
import { default as indexbYcmpcN6Oq9NnPreaGEKfehHVEs7Ul_45apxhxzlefbwIMeta } from "/app/pages/fg/index.vue?macro=true";
import { default as indexL1kdvb8fMAQ0MgtPn6_y60ukl6iwMLNkVA7kH4LpgPYMeta } from "/app/pages/esim/index.vue?macro=true";
import { default as ratesDDViYnDjKQTdt9ZcrvPUulvbXjctHQbugbUpvfP_uL4Meta } from "/app/pages/esim/rates.vue?macro=true";
import { default as paymentMxWenglIQR4M2K6A_45ehP_4588Z3m_9cSooqfuMEOfd8OEMeta } from "/app/pages/fg/payment.vue?macro=true";
import { default as main_reportM8mT9a5MKVqxelZjVYRuIGQjH7JO9M5P7HMX_453mJmrwMeta } from "/app/pages/main_report.vue?macro=true";
import { default as importsk3Q8ENMUGN1KNQULN3E_Xv1_SejRExu_CUeKG25f498Meta } from "/app/pages/esim/imports.vue?macro=true";
import { default as expenses43P0H4E5MwvaNPbOvYfSIUOj_DqS1tiPzZsu8nS9gd0Meta } from "/app/pages/fin/expenses.vue?macro=true";
import { default as access_45deniedyHIOCACFsmpwjlfzNSutDWeVNnmI4q3U6OE5LDoq354Meta } from "/app/pages/access-denied.vue?macro=true";
import { default as indexYLkN12r2e4JdaqaJ9cpZ4m5U3UiHFAlKxlJYyjz4utwMeta } from "/app/pages/refunds/index.vue?macro=true";
import { default as issueMVVVk4Pem2_45ZUEyF0TuAmg4nE0NH5DH3rvGs7MfPDaYMeta } from "/app/pages/refunds/issue.vue?macro=true";
import { default as topuptj2ASHm9PN83z_PF4JLY2lXQk7tdTArJW1_xs8o0rRoMeta } from "/app/pages/refunds/topup.vue?macro=true";
import { default as inventoryPUywUoSvZKR7wIfWlh0rZuaIXDMZQeaoHKaOY79u43EMeta } from "/app/pages/esim/inventory.vue?macro=true";
import { default as master_45accountYJnwQOhC8TDEdB313gTEPg6OmAiytrhssYp9y0sDIUwMeta } from "/app/pages/master-account.vue?macro=true";
import { default as main_report_new8bgCwrCGgI8Q_UNXl17vx2HxAJyx32zRkcoffPA7iwUMeta } from "/app/pages/main_report_new.vue?macro=true";
import { default as main_report_old5G8O_aQqdqpFGd6VbMWnK1QhDegxD2PoMfkUxBv32tAMeta } from "/app/pages/main_report_old.vue?macro=true";
import { default as test_main_reportgI6KM0auVj2vwOm4oXRuM0U6mwfN4CLUzApXq_45e0vCsMeta } from "/app/pages/test_main_report.vue?macro=true";
import { default as index5pLzhte9TQJTRsGOs2AddcvDJPJut_pUUCJmurfv3M0Meta } from "/app/pages/admin/roles/index.vue?macro=true";
import { default as indexgvs7WdV1NLBsiIM1p5V4txUPTMYikQ1vfsYYESmgxtgMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as pgyHCSW7We_pKXPQyeHZOXwECm6fdXBMB4xQkN_451V4UqEMeta } from "/app/pages/cc/datasources/pg.vue?macro=true";
import { default as cards_issue_ordersZYFh5Zeh9bB2pT8w0l3E_todAVsTlfwrK_czSwwcbXsMeta } from "/app/pages/cards_issue_orders.vue?macro=true";
import { default as cards_topup_orders9QdadP3U7cAWUOz8EVcZu5Oa1F70c7BT66KyZukKnocMeta } from "/app/pages/cards_topup_orders.vue?macro=true";
import { default as indexKCxi85oQpoCX717o_nP2USoBSGO0GgCt35sxmzP6bh0Meta } from "/app/pages/amoka-operations/index.vue?macro=true";
import { default as wallet_45yield_45analyticsFcPuBmlzOPpjLO_453tjrVz7ginKAh4EUMcYi7j8qc93UMeta } from "/app/pages/wallet-yield-analytics.vue?macro=true";
import { default as indexFPuOMcyN5u9oBVIt2dUJ0FqFp5xmUq5crf6Zbhm4qc0Meta } from "/app/pages/trader_deposit_rub/index.vue?macro=true";
import { default as wallet_45yield_45ab_45segmentsfHR7SJzzPH7SUBI9vJ7jPNM8D_GmDnyzuN_45ARqA5WOsMeta } from "/app/pages/wallet-yield-ab-segments.vue?macro=true";
import { default as indexh9quYT60eXieXgGAP7t0wrgOmu5TkECgGxTdy7G9TxYMeta } from "/app/pages/communications/help/index.vue?macro=true";
import { default as indexZ8HcU_cEKXWqG1apP5sSCu90nImkKq_rshpW5B4kuBgMeta } from "/app/pages/finance-kpi-reports/index.vue?macro=true";
import { default as indexYmL6AVbPbwZ0_45J41jvHS9fPwcqvt6wkPanP_hV7CJD4Meta } from "/app/pages/system/project_vars/index.vue?macro=true";
import { default as indexhi6nj2vKBVSVig_1bvu_45Sykp3cxhZOX1uopGSv36HsIMeta } from "/app/pages/communications/stats/index.vue?macro=true";
import { default as pageBWJTpdE422yOFhEZpRwSPsUiPZwnZGy_UjK733NDE0EMeta } from "/app/pages/communications/help/ui/page.vue?macro=true";
import { default as indexYNwwpGagE25pFvhlcW2VgJZB3wMMo63MxAtd36_umrsMeta } from "/app/pages/communications/help/api/index.ts?macro=true";
import { default as index6tlxz1PmrL3s7ijFnq6asBmWCrEqdvaPvpENFt6x8E0Meta } from "/app/pages/communications/help/lib/index.ts?macro=true";
import { default as pagehl5rqN8Orm7_aC8g6AoU4CQ0XW9WtjOJCQiot4qEB1sMeta } from "/app/pages/communications/stats/ui/page.vue?macro=true";
import { default as indexSWjeuU9ITkUlsj4s3fwVu0bFMJqbzSz3nwBxjxfM7_45QMeta } from "/app/pages/communications/stats/api/index.ts?macro=true";
import { default as indexXy1GrJ00fzkesVUUWgskOZpMIPQhWou0wOdfbnrm_458AMeta } from "/app/pages/communications/stats/lib/index.ts?macro=true";
import { default as indexhMCDMnqqDD9pLVKGRL_4501G9O4UqMGvK6jVsCh7OIl6EMeta } from "/app/pages/communications/help/model/index.ts?macro=true";
import { default as indexZYbEJJ_4557cndaF06nh29oziFN1wX3UWq3dCBvHLnWqgMeta } from "/app/pages/communications/help/config/index.ts?macro=true";
import { default as indexywHLExQwPFwV8uD1L_50Lrhe97xK8nMQ7ykqYFOsPt8Meta } from "/app/pages/communications/push-rules/index.vue?macro=true";
import { default as index1CpER7kDOv642mavfG6HCWDSl92JRZFhp5u2Ws6xiwUMeta } from "/app/pages/communications/stats/model/index.ts?macro=true";
import { default as indexqnECAedFkAbHGtJlYKd4cYm5vVjmkJxUXb0CJQ96QKcMeta } from "/app/pages/communications/newsletters/index.vue?macro=true";
import { default as indexs8Uu6LFFvvNCjNkcpxRGjav0bepzGW8xJdSRm2FjvWEMeta } from "/app/pages/communications/stats/config/index.ts?macro=true";
import { default as pageyqay5kGFSFx7upkO1SYQ3PQ63HnK7UpC_DQBLGit864Meta } from "/app/pages/communications/push-rules/ui/page.vue?macro=true";
import { default as pageDzuP5OAam_45rGxEOol1bT6QNjp_45ImYzeUVlsQqgNARhEMeta } from "/app/pages/communications/newsletters/ui/page.vue?macro=true";
import { default as indexlLfEhCSsjxsLFJ6jYpBuG0DOMtPdraQMq98WMjeTo3oMeta } from "/app/pages/communications/push-rules/api/index.ts?macro=true";
import { default as indexVIohoBZsQo4h8jx1vO3oKlELa2e2u67StLFt4X06MpoMeta } from "/app/pages/communications/push-rules/lib/index.ts?macro=true";
import { default as indexKLEaiteMn2TlnOm10sXZqgt5FuYKjK8bu_yjd5hVP7UMeta } from "/app/pages/communications/newsletters/api/index.ts?macro=true";
import { default as indexKiE47wItN0bon_n62sdUR4_Pteifi_Ob93c5OflXUS4Meta } from "/app/pages/communications/newsletters/lib/index.ts?macro=true";
import { default as table_wtBRHA052dKpmPfBKfcjfdIm7FeT__455R686wvrawfgMeta } from "/app/pages/communications/newsletters/ui/table.vue?macro=true";
import { default as indexMiUD1AQgsfMhiZ3Fbdan5IhNO2s9yTyRROz5p0TR9poMeta } from "/app/pages/communications/push-rules/model/index.ts?macro=true";
import { default as indexyWXpin4pGhKZ8gtJzPrVvFh2YHwq6FEIxmCqz2mM_45ZEMeta } from "/app/pages/communications/tma-modal-alert/index.vue?macro=true";
import { default as indexB4Okhl9W_45lSmqZSApfWNKcqewKKodaJ8dj69w0rYd2AMeta } from "/app/pages/communications/newsletters/model/index.ts?macro=true";
import { default as toolbartR9azIf8_45NXFV9fvGqUwe1rv8iuvPvLzN_MDT99RZD4Meta } from "/app/pages/communications/newsletters/ui/toolbar.vue?macro=true";
import { default as indexxcbCb3Ichw4pvfqXzNl_45CKHq0B_45XJodl3xzNssL6pqwMeta } from "/app/pages/communications/push-rules/config/index.ts?macro=true";
import { default as index2R_8IPQzUIWFyx0J0oXOqMgrizLFPOldDQmLQE6X_XAMeta } from "/app/pages/communications/tma-utm-taxonomy/index.vue?macro=true";
import { default as providers_master_account_topup_ordersjWjNK9oNhBbVrJ9h3JZywrSPwS3axidOQzuwetXLaXoMeta } from "/app/pages/providers_master_account_topup_orders.vue?macro=true";
import { default as indexVlpuHSoEU1KTdV7jmXgcqYZnWxRYvcCm3m901hHw5G0Meta } from "/app/pages/communications/newsletters/config/index.ts?macro=true";
import { default as indexhPmZfDioM6XH6bgMoEbnTywmgqVw2pr796clkW4EMkgMeta } from "/app/pages/communications/tma-utm-analytics/index.vue?macro=true";
import { default as indexE0MrxoYt0HF8YfgpPTWalA55UTzxyY_zMuWiyCRhKiUMeta } from "/app/pages/communications/target-collections/index.vue?macro=true";
import { default as use_45commandsyN2tDwwrtoeKGUHu4XGaHG4xpwWOUFXqiWnyLOhagSQMeta } from "/app/pages/communications/newsletters/lib/use-commands.ts?macro=true";
export default [
  {
    name: "lp",
    path: "/lp",
    component: () => import("/app/pages/lp.vue")
  },
  {
    name: "txs",
    path: "/txs",
    component: () => import("/app/pages/txs.vue")
  },
  {
    name: "cards",
    path: "/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/app/pages/users.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "staking",
    path: "/staking",
    component: () => import("/app/pages/staking.vue")
  },
  {
    name: "cc",
    path: "/cc",
    component: () => import("/app/pages/cc/index.vue")
  },
  {
    name: "fg",
    path: "/fg",
    component: () => import("/app/pages/fg/index.vue")
  },
  {
    name: "esim",
    path: "/esim",
    meta: indexL1kdvb8fMAQ0MgtPn6_y60ukl6iwMLNkVA7kH4LpgPYMeta || {},
    redirect: "/esim/imports",
    component: () => import("/app/pages/esim/index.vue")
  },
  {
    name: "esim-rates",
    path: "/esim/rates",
    component: () => import("/app/pages/esim/rates.vue")
  },
  {
    name: "fg-payment",
    path: "/fg/payment",
    meta: paymentMxWenglIQR4M2K6A_45ehP_4588Z3m_9cSooqfuMEOfd8OEMeta || {},
    component: () => import("/app/pages/fg/payment.vue")
  },
  {
    name: "main_report",
    path: "/main_report",
    component: () => import("/app/pages/main_report.vue")
  },
  {
    name: "esim-imports",
    path: "/esim/imports",
    component: () => import("/app/pages/esim/imports.vue")
  },
  {
    name: "fin-expenses",
    path: "/fin/expenses",
    component: () => import("/app/pages/fin/expenses.vue")
  },
  {
    name: "access-denied",
    path: "/access-denied",
    meta: access_45deniedyHIOCACFsmpwjlfzNSutDWeVNnmI4q3U6OE5LDoq354Meta || {},
    component: () => import("/app/pages/access-denied.vue")
  },
  {
    name: "refunds",
    path: "/refunds",
    meta: indexYLkN12r2e4JdaqaJ9cpZ4m5U3UiHFAlKxlJYyjz4utwMeta || {},
    redirect: "/refunds/topup",
    component: () => import("/app/pages/refunds/index.vue")
  },
  {
    name: "refunds-issue",
    path: "/refunds/issue",
    component: () => import("/app/pages/refunds/issue.vue")
  },
  {
    name: "refunds-topup",
    path: "/refunds/topup",
    component: () => import("/app/pages/refunds/topup.vue")
  },
  {
    name: "esim-inventory",
    path: "/esim/inventory",
    component: () => import("/app/pages/esim/inventory.vue")
  },
  {
    name: "master-account",
    path: "/master-account",
    component: () => import("/app/pages/master-account.vue")
  },
  {
    name: "main_report_new",
    path: "/main_report_new",
    component: () => import("/app/pages/main_report_new.vue")
  },
  {
    name: "main_report_old",
    path: "/main_report_old",
    component: () => import("/app/pages/main_report_old.vue")
  },
  {
    name: "test_main_report",
    path: "/test_main_report",
    component: () => import("/app/pages/test_main_report.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    component: () => import("/app/pages/admin/roles/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "cc-datasources-pg",
    path: "/cc/datasources/pg",
    component: () => import("/app/pages/cc/datasources/pg.vue")
  },
  {
    name: "cards_issue_orders",
    path: "/cards_issue_orders",
    component: () => import("/app/pages/cards_issue_orders.vue")
  },
  {
    name: "cards_topup_orders",
    path: "/cards_topup_orders",
    component: () => import("/app/pages/cards_topup_orders.vue")
  },
  {
    name: "amoka-operations",
    path: "/amoka-operations",
    component: () => import("/app/pages/amoka-operations/index.vue")
  },
  {
    name: "wallet-yield-analytics",
    path: "/wallet-yield-analytics",
    component: () => import("/app/pages/wallet-yield-analytics.vue")
  },
  {
    name: "trader_deposit_rub",
    path: "/trader_deposit_rub",
    component: () => import("/app/pages/trader_deposit_rub/index.vue")
  },
  {
    name: "wallet-yield-ab-segments",
    path: "/wallet-yield-ab-segments",
    component: () => import("/app/pages/wallet-yield-ab-segments.vue")
  },
  {
    name: "communications-help",
    path: "/communications/help",
    component: () => import("/app/pages/communications/help/index.vue")
  },
  {
    name: "finance-kpi-reports",
    path: "/finance-kpi-reports",
    component: () => import("/app/pages/finance-kpi-reports/index.vue")
  },
  {
    name: "system-project_vars",
    path: "/system/project_vars",
    component: () => import("/app/pages/system/project_vars/index.vue")
  },
  {
    name: "communications-stats",
    path: "/communications/stats",
    component: () => import("/app/pages/communications/stats/index.vue")
  },
  {
    name: "communications-help-ui-page",
    path: "/communications/help/ui/page",
    component: () => import("/app/pages/communications/help/ui/page.vue")
  },
  {
    name: "communications-help-api",
    path: "/communications/help/api",
    component: () => import("/app/pages/communications/help/api/index.ts")
  },
  {
    name: "communications-help-lib",
    path: "/communications/help/lib",
    component: () => import("/app/pages/communications/help/lib/index.ts")
  },
  {
    name: "communications-stats-ui-page",
    path: "/communications/stats/ui/page",
    component: () => import("/app/pages/communications/stats/ui/page.vue")
  },
  {
    name: "communications-stats-api",
    path: "/communications/stats/api",
    component: () => import("/app/pages/communications/stats/api/index.ts")
  },
  {
    name: "communications-stats-lib",
    path: "/communications/stats/lib",
    component: () => import("/app/pages/communications/stats/lib/index.ts")
  },
  {
    name: "communications-help-model",
    path: "/communications/help/model",
    component: () => import("/app/pages/communications/help/model/index.ts")
  },
  {
    name: "communications-help-config",
    path: "/communications/help/config",
    component: () => import("/app/pages/communications/help/config/index.ts")
  },
  {
    name: "communications-push-rules",
    path: "/communications/push-rules",
    component: () => import("/app/pages/communications/push-rules/index.vue")
  },
  {
    name: "communications-stats-model",
    path: "/communications/stats/model",
    component: () => import("/app/pages/communications/stats/model/index.ts")
  },
  {
    name: "communications-newsletters",
    path: "/communications/newsletters",
    component: () => import("/app/pages/communications/newsletters/index.vue")
  },
  {
    name: "communications-stats-config",
    path: "/communications/stats/config",
    component: () => import("/app/pages/communications/stats/config/index.ts")
  },
  {
    name: "communications-push-rules-ui-page",
    path: "/communications/push-rules/ui/page",
    component: () => import("/app/pages/communications/push-rules/ui/page.vue")
  },
  {
    name: "communications-newsletters-ui-page",
    path: "/communications/newsletters/ui/page",
    component: () => import("/app/pages/communications/newsletters/ui/page.vue")
  },
  {
    name: "communications-push-rules-api",
    path: "/communications/push-rules/api",
    component: () => import("/app/pages/communications/push-rules/api/index.ts")
  },
  {
    name: "communications-push-rules-lib",
    path: "/communications/push-rules/lib",
    component: () => import("/app/pages/communications/push-rules/lib/index.ts")
  },
  {
    name: "communications-newsletters-api",
    path: "/communications/newsletters/api",
    component: () => import("/app/pages/communications/newsletters/api/index.ts")
  },
  {
    name: "communications-newsletters-lib",
    path: "/communications/newsletters/lib",
    component: () => import("/app/pages/communications/newsletters/lib/index.ts")
  },
  {
    name: "communications-newsletters-ui-table",
    path: "/communications/newsletters/ui/table",
    component: () => import("/app/pages/communications/newsletters/ui/table.vue")
  },
  {
    name: "communications-push-rules-model",
    path: "/communications/push-rules/model",
    component: () => import("/app/pages/communications/push-rules/model/index.ts")
  },
  {
    name: "communications-tma-modal-alert",
    path: "/communications/tma-modal-alert",
    component: () => import("/app/pages/communications/tma-modal-alert/index.vue")
  },
  {
    name: "communications-newsletters-model",
    path: "/communications/newsletters/model",
    component: () => import("/app/pages/communications/newsletters/model/index.ts")
  },
  {
    name: "communications-newsletters-ui-toolbar",
    path: "/communications/newsletters/ui/toolbar",
    component: () => import("/app/pages/communications/newsletters/ui/toolbar.vue")
  },
  {
    name: "communications-push-rules-config",
    path: "/communications/push-rules/config",
    component: () => import("/app/pages/communications/push-rules/config/index.ts")
  },
  {
    name: "communications-tma-utm-taxonomy",
    path: "/communications/tma-utm-taxonomy",
    component: () => import("/app/pages/communications/tma-utm-taxonomy/index.vue")
  },
  {
    name: "providers_master_account_topup_orders",
    path: "/providers_master_account_topup_orders",
    component: () => import("/app/pages/providers_master_account_topup_orders.vue")
  },
  {
    name: "communications-newsletters-config",
    path: "/communications/newsletters/config",
    component: () => import("/app/pages/communications/newsletters/config/index.ts")
  },
  {
    name: "communications-tma-utm-analytics",
    path: "/communications/tma-utm-analytics",
    component: () => import("/app/pages/communications/tma-utm-analytics/index.vue")
  },
  {
    name: "communications-target-collections",
    path: "/communications/target-collections",
    component: () => import("/app/pages/communications/target-collections/index.vue")
  },
  {
    name: "communications-newsletters-lib-use-commands",
    path: "/communications/newsletters/lib/use-commands",
    component: () => import("/app/pages/communications/newsletters/lib/use-commands.ts")
  }
]